import { Scene } from 'phaser';
import { TweenAction } from './TweenAction';

export class AlphaAction extends TweenAction {
  protected alpha: number;

  constructor(scene: Scene, targets: any, duration: number, alpha: number) {
    super(scene, targets, duration);
    this.alpha = alpha;
  }

  protected setTweenConfig() {
    super.setTweenConfig();
    this.setTweenConfigValue('alpha', this.alpha);
  }
}